module.exports = __webpack_public_path__ + "img/87.2cbefd9b.jpg";